import { render } from "./SbmCeoDashboard.vue?vue&type=template&id=21f9eb80&scoped=true"
import script from "./SbmCeoDashboard.vue?vue&type=script&lang=js"
export * from "./SbmCeoDashboard.vue?vue&type=script&lang=js"

import "./SbmCeoDashboard.vue?vue&type=style&index=0&id=21f9eb80&lang=css"
import "./SbmCeoDashboard.vue?vue&type=style&index=1&id=21f9eb80&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\TRAVEL SAFE\\kite-app-api\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f9eb80"]])

export default __exports__